import { Controller } from "@hotwired/stimulus"

// アイコン画像のファイル選択プレビューと「アイコンを削除」リンクの制御。
// 使い方:
//   <div data-controller="icon-preview">
//     <img data-icon-preview-target="image" class="hidden">
//     <span data-icon-preview-target="placeholder">?</span>
//     <input type="file" data-icon-preview-target="input" data-action="change->icon-preview#preview">
//     <a data-icon-preview-target="removeLink" data-action="click->icon-preview#markForRemoval">アイコンを削除</a>
//     <input type="hidden" data-icon-preview-target="removeField" value="0">
//   </div>
export default class extends Controller<HTMLElement> {
  static targets = ["image", "placeholder", "input", "inputWrapper", "removeLink", "removeField"]

  declare readonly imageTarget: HTMLImageElement
  declare readonly placeholderTarget: HTMLElement
  declare readonly inputTarget: HTMLInputElement
  declare readonly hasInputWrapperTarget: boolean
  declare readonly inputWrapperTarget: HTMLElement
  declare readonly hasRemoveLinkTarget: boolean
  declare readonly removeLinkTarget: HTMLElement
  declare readonly hasRemoveFieldTarget: boolean
  declare readonly removeFieldTarget: HTMLInputElement

  preview() {
    const file = this.inputTarget.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (event) => {
      this.imageTarget.src = event.target?.result as string
      this.imageTarget.classList.remove("hidden")
      this.placeholderTarget.classList.add("hidden")
      if (this.hasRemoveFieldTarget) this.removeFieldTarget.value = "0"
    }
    reader.readAsDataURL(file)
  }

  markForRemoval(event: Event) {
    event.preventDefault()

    this.removeFieldTarget.value = "1"
    this.imageTarget.classList.add("hidden")
    this.imageTarget.removeAttribute("src")
    this.placeholderTarget.classList.remove("hidden")
    if (this.hasRemoveLinkTarget) this.removeLinkTarget.classList.add("hidden")
    if (this.hasInputWrapperTarget) this.inputWrapperTarget.classList.remove("hidden")
  }
}
